import React from "react";

import { useTableKeyboardNavigation } from "@progress/kendo-react-data-tools";
import { GRID_COL_INDEX_ATTRIBUTE } from "@progress/kendo-react-grid";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";

export default function GridDateCell(props) {
  const { i18n } = useTranslation();
  const value = props.dataItem[props.field];
  const navigationAttributes = useTableKeyboardNavigation(props.id);
  var date;
  if (value === null || value === undefined || value === "") {
    date = "";
  } else {
    date = new Date(value);
    date = DateTime.fromObject({
      day: date.getDate(),
      month: date.getMonth() + 1,
      year: date.getFullYear(),
    })
      .setLocale(i18n.language)
      .toFormat("dd MMMM yyyy");
  }
  return (
    <td
      title={value?.replace("T00:00:00", "")}
      aria-selected={props.isSelected}
      colSpan={props.colSpan}
      aria-colindex={props.ariaColumnIndex}
      {...{ [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex }}
      {...navigationAttributes}
    >
      {date || "-"}
    </td>
  );
}
